import { formatMoney, isWithinTolerance } from '@klopotun/domain';
import type { LinkPeriod } from '../../../entities/bank-transaction/index.js';
import {
  formatStoredDateForPeople,
  VARIABLE_AMOUNT_TEXT,
} from '../../../features/payment-view/index.js';

const STATUS_TEXT: Record<LinkPeriod['status'], string> = {
  planned: 'заплановано',
  paid: 'оплачено вручну',
};

const expectedAmountTextOf = (period: LinkPeriod): string =>
  period.amountMinor === null
    ? VARIABLE_AMOUNT_TEXT
    : formatMoney({ amountMinor: period.amountMinor, currency: period.currency });

export const linkPeriodLabelOf = (period: LinkPeriod): string =>
  [
    formatStoredDateForPeople(period.dueDate),
    STATUS_TEXT[period.status],
    expectedAmountTextOf(period),
  ].join(' · ');

export const linkedMoneyTextOf = (period: LinkPeriod): string =>
  formatMoney({ amountMinor: period.bankAmountMinor, currency: period.bankCurrency });

export const amountMismatchTextOf = (period: LinkPeriod): string | null => {
  const isSameCurrency = period.bankCurrency === period.currency;

  if (!isSameCurrency || period.amountMinor === null) {
    return null;
  }

  if (isWithinTolerance(period.bankAmountMinor, period.amountMinor)) {
    return null;
  }

  const expected = formatMoney({ amountMinor: period.amountMinor, currency: period.currency });

  return `Сума ${linkedMoneyTextOf(period)} не схожа на ${expected} — перевірте підписку.`;
};
